<template>
  <div class="box_container" :style="{ 'background-image': `url(${cmsObj.bg})`}">
    <div class="logo-box"><img :src="cmsObj.logo" class="logo"></div>
    <div class="layout">
      <div class="layout-left">
        <div class="playbox">
          <div class="play-cover" v-if="playStatus == 0">
            <img :src="cmsObj.cover" class="cover" @click="onPlay">
            <img src="../../assets/img/cooperation/play.png" class="play" @click="onPlay">

          </div>
          <div style="text-align: left;" v-else>
            <!-- <img :src="cmsObj.cover" class="cover1" > -->
            <video id="videoBox" class="video" controls autoplay preload="auto" :poster="cmsObj.cover">
              <source :src="cmsObj.video" type="video/mp4" />
            </video>
          </div>
        </div>
        <div class="content">
          <div class="content-left">
            <div class="inner">
              <div class="heading">
                <img :src="cmsObj.titleLeft" class="titleImg">
              </div>
              <div class="desc">
                <div v-html="cmsObj.titleLeftContent" class="content-desc">

                </div>
              </div>
            </div>
          </div>
          <div class="content-right">
            <div class="inner">
              <div class="heading">
                <img :src="cmsObj.titleRight" class="titleImg">
              </div>
              <div class="desc">
                <img :src="cmsObj.storeImge">
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="layout-right">
        <img :src="cmsObj.floatimg" @click="goDinner" class="floatimg">

      </div>
    </div>


  </div>
</template>

<script>
  export default {
    data() {
      return {
        storyData: '',
        //视频播放状态
        playStatus:false,
        prepaidcardData:null,
        dataList:[],
        cmsObj:{
          bg:'',
          logo:'',
          cover:'',
          video:'',
          content:'',
          floatimg:'',
          titleLeft:'',
          titleLeftContent: '',
          titleRight:'',
          storeImge:'', 
          menuUrl:'',
        }
      }
    },
    computed: {
      lang() {
        return this.$i18n.locale;
      }
    },
    created() {
      this.getTemplateByModule();
    },
    methods: {
      //播放视频
      onPlay() {
        this.playStatus = true;
        const video = document.getElementById('videoBox');
        video.play();
        // CDP埋点 [点击视频播放]
        this.CDP('播放视频');
        // 神策埋点:页面浏览
        this.$Sensors.track('BJHLPageView', { page_name: "官网白荆回廊合作活动页", button_name: '播放视频' })
      },
      //去点餐
      goDinner() {
        
        if(this.cmsObj.menuUrl) {
           sessionStorage.setItem('HZTag', 'HZ');
           this.$router.push({ path: this.cmsObj.menuUrl });
           this.CDP('点餐页面');
           // 神策埋点:跳转点餐页面
          this.$Sensors.track('BJHLPageClick', { page_name: "官网白荆回廊合作活动页", button_name: '点餐页面' })
        }else {
          return;
        }
      },
     //官网IP合作获取数据
       getTemplateByModule() {
        this.$post("getTemplateByModule",)
        .then(res => {
          if (res.data.code == 200) {
          
            this.dataList = res.data.data;
            // this.dataList = res.data && res.data.data[0] && res.data.data[0].temImg.cnImg || ''
            this.dataList.forEach(item => {
        
              switch (item.groupKey) {
                 case 'bg:gameBg':
                  this.cmsObj.bg = item.list[0].temImg.cnImg
                  break;
                 case "logo:gameLogo":
                  this.cmsObj.logo = item.list[0].temImg.cnImg
                  break;
                 case "video:gamevideoImg":
                  this.cmsObj.cover = item.list[0].temImg.cnImg;
                  this.cmsObj.video = item.list[0].temImg.url;
                  break;
                 case "floatimg:floatBtn":
                  this.cmsObj.floatimg = item.list[0].temImg.cnImg
                  this.cmsObj.menuUrl = item.list[0].temImg.url;
                  break;
                 case "img-1:gameimg2":
                  this.cmsObj.content = item.list[0].temImg.cnImg
                  break;
                    case "ashactiveintro:pc":
                  this.cmsObj.titleLeft = item.list[0].titleAndBackground.backgroundImg;
                  this.cmsObj.titleLeftContent = item.list[0].richText.chText1;
                  break;
                 case "ashstoreintro:pc":
                  this.cmsObj.titleRight = item.list[0].titleAndBackground.backgroundImg;
                  this.cmsObj.storeImge = item.list[0].temImg.cnImg; 
                  break;
                 default:
                
              }
            
            })
          }
        }, err => {
          console.log('err'.err)
        });
      },
      //CDP埋点方法
       CDP(text) {
        try {
            clab_tracker.ready(function () { // CDP埋点
              this.track('c_click_bjhlpage', { 
                  // 弹窗名称
                buttonId: '',
                // 按钮名称
                c_buttonName: text,
              });
            });
          } catch (error) {

          }
    },
    }
  }
</script>

<style lang="scss" scoped>
html{
    font-size:1vw; 
}
.box_container {
    background-repeat: repeat;
    background-position: top;
    width: 100vw;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.logo-box {
  padding: 15px 0 0 20px;
  text-align: left;
  .logo {
  width: 30%;
}
}

.layout {
  display: flex;
  overflow: hidden;
  padding-left: 40px;
  
  .layout-left {
    flex: 1;
    position: relative;
    .playbox {
      position: relative;
   .cover {
      width: 100%;
      height: 41vw;
      border-radius: 10px;
      border: 3px solid #fddd88;
      box-shadow: 0 0 5px rgba(0,0,0,0.5);
    }
   #videoBox {
    height: 41vw;
    border: 3px solid #fff;
    border-radius: 10px;
    }
  .play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 100px;
    height: 100px;
    opacity: 0.7;
    transition: transform 1s ease-out;
    cursor: pointer;
    &:hover {
      transition: transform 1s ease-out;
        opacity: 1;
    }
  }
}
  }
  .layout-right {
    width: 23vw;
    .floatimg {
      width: 100%;
    }
  }
}

.content {
  display: flex;
  padding: 10px 0;
  padding-bottom: 50px;
  .inner {
  border-radius: 10px;
    border: 3px solid #fddd88;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    padding: 15px;
    min-height: 140px;
  }
  .content-left {
    flex: 1;
    padding-right: 20px;
    position: relative;
  
    .heading {
      text-align: left;
      .titleImg {
       height: 50px;
       position: absolute;
       top: -7px;
       left: -10px;
      }
    }
    .desc {
      text-align: left;
      .content-desc {
        height: 100px;
        overflow-y: auto;
        font-size: 16px;
        color: #fff;
        font-weight: 700;
        text-shadow: 0 0 1px rgba(0,0,0,0.3);
        padding-top: 30px;
      }
    }
  }
  .content-right {
  position: relative;
    flex: 1;
 
     .heading {
      text-align: left;
        .titleImg {
        height: 50px;
        position: absolute;
        top: -7px;
        left: -10px;
      }
    }
     .desc {
      text-align: left;
      padding-top: 30px;
    }
  }
}
</style>
